module.exports = __webpack_public_path__ + "static/img/trackPay.df8f6a45.png";